@if (isAuthenticated()) {
  <div class="main-container">
    @if (isSystemAdmin()) {
      <cui-app-container>
        <cui-top-menu [backgroundColor]="topBgColor">
          <cui-top-menu-item class="no-interaction" [iconName]="'person'" [text]="userModel().userinfo.name"></cui-top-menu-item>
          <cui-top-menu-item [iconName]="'logout'" [tooltipText]="'Log out'" (click)="logout()"></cui-top-menu-item>
        </cui-top-menu>
        <cui-side-nav-container (keydown.arrowdown)="onNavArrowKey($event)" (keydown.arrowup)="onNavArrowKey($event)">
          <ng-container class="body">
            <cui-side-nav-item
              icon="dashboard.svg"
              url="/dashboard"
              [name]="'Dashboard'"
              (linkClicked)="onLinkClicked($event)"
            ></cui-side-nav-item>
            @if (hasPartnersPermission) {
              <cui-side-nav-item
                icon="collaboration.svg"
                url="/partners"
                [name]="'Partners'"
                (linkClicked)="onLinkClicked($event)"
              ></cui-side-nav-item>
            }
            @if (hasUserPermission) {
              <cui-side-nav-item icon="people.svg" url="/users" [name]="'Users'" (linkClicked)="onLinkClicked($event)"></cui-side-nav-item>
            }
            @if (hasCustomersPermission) {
              <cui-side-nav-item
                icon="users.svg"
                url="/customers"
                [name]="'Customers'"
                (linkClicked)="onLinkClicked($event)"
              ></cui-side-nav-item>
            }
            @if (navExpandProductsAndOrders.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandProductsAndOrders" (linkClicked)="onLinkClicked($event)">
              </cui-side-nav-expand>
            }
            @if (navExpandCsp.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandCsp" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
            @if (navExpandMarketing.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandMarketing" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
            @if (navExpandNotifications.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandNotifications" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
            @if (hasAgreementPermission) {
              <cui-side-nav-item icon="document.svg" url="/agreements" [name]="'Agreements'" (linkClicked)="onLinkClicked($event)">
              </cui-side-nav-item>
            }
            @if (navExpandAuthorization.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandAuthorization" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
            @if (navExpandCommonData.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandCommonData" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
            @if (navExpandActions.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandActions" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
            @if (navExpandFileManagement.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandFileManagement" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
            @if (navExpandMonitoring.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandMonitoring" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
            @if (navExpandJobOrchestrator.length > 0) {
              <cui-side-nav-expand [navExpandNodes]="navExpandJobOrchestrator" (linkClicked)="onLinkClicked($event)"> </cui-side-nav-expand>
            }
          </ng-container>
        </cui-side-nav-container>
        <div class="body">
          <cui-page-title></cui-page-title>
          <router-outlet></router-outlet>
        </div>
      </cui-app-container>
    } @else {
      <div class="card">
        <cui-card>
          <cui-card-header>
            <h2>Access denied</h2>
          </cui-card-header>
          <cui-card-body
            >This user doesn't have access. Click <strong><a class="active-text" (click)="logout()">here</a></strong> to logout and try with
            another user.</cui-card-body
          >
        </cui-card>
      </div>
    }
  </div>
}
